/**
 * @generated SignedSource<<a2586e821304deb18260a8c288742669>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type GetJobsQuery$variables = {};
export type GetJobsQuery$data = {
  readonly getJobs: ReadonlyArray<{
    readonly customer: {
      readonly categoryId: string | null;
      readonly id: string;
      readonly key: string;
      readonly name: string;
    };
    readonly customerId: string;
    readonly description: string | null;
    readonly id: string;
    readonly jobCategory: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly jobCategoryId: string;
    readonly key: string;
    readonly regions: ReadonlyArray<{
      readonly enabled: boolean;
      readonly id: string;
      readonly name: string;
    }> | null;
    readonly status: string;
  }>;
};
export type GetJobsQuery = {
  response: GetJobsQuery$data;
  variables: GetJobsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Job",
    "kind": "LinkedField",
    "name": "getJobs",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "customer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "categoryId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jobCategoryId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "JobCategory",
        "kind": "LinkedField",
        "name": "jobCategory",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Region",
        "kind": "LinkedField",
        "name": "regions",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "GetJobsQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "GetJobsQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "802c718733cbde6a554133b32c062e9e",
    "id": null,
    "metadata": {},
    "name": "GetJobsQuery",
    "operationKind": "query",
    "text": "query GetJobsQuery {\n  getJobs {\n    id\n    key\n    description\n    customerId\n    customer {\n      id\n      key\n      name\n      categoryId\n    }\n    jobCategoryId\n    jobCategory {\n      id\n      name\n    }\n    status\n    regions {\n      id\n      name\n      enabled\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5715ef846e28d90ff4aae30fe20295ce";

export default node;
